import PropTypes from 'prop-types';
import React from 'react';

import { Row, Col, FormGroup, Label, Switch as TWSwitch, FormSection, FormCard, Separator } from 'twyne-new.ui'

import { getCountryOptions } from '@/components/rules/options';
import ActiveSessions from '@/modules/profile/views/my-profile/components/ActiveSessions';
import Checkbox from 'components/form/Checkbox';
import Input from 'components/form/Input';
import Select from 'components/form/Select';
import Switch from 'components/form/Switch';

import AdminForm from './AdminForm';
import TwoFactorAuthentication from './Authentication';
import Password from './Password';

const genderOptions = [
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
]

class UserForm extends React.Component {
  state = {
    gender: null,
    active: true,
    changePassword: false,
  };

  componentWillMount() {
    const { data } = this.props;
    if (data) {
      this.setState(data);
    }
  }

  componentWillReceiveProps(props) {
    const { data } = props;
    if (data) {
      this.setState(data);
    }
  }

  handleChangeGender = option => {
    const gender = option ? option.value : null;
    this.setState({ gender });
  }

  handleChangePasswordChecked = checked => {
    const changePassword = checked;
    let { password } = this.state
    if (!checked) {
      password = null
    }
    this.setState({ changePassword, password });
  }

  handleChangePassword = value => {
    const password = value ? value : "";
    this.setState({ password })
  }

  UserInformation = () => <Row>
    <Col size="12">
      <FormGroup>
        <Label>Email</Label>
        <Input name="email" value={this.state.email || ''}
          validations="isEmail" validationError="You have to type valid email" required />
      </FormGroup>
    </Col>
    <Col size="6">
      <FormGroup>
        <Label>First Name</Label>
        <Input name="first_name" value={this.state.first_name || ''} required />
      </FormGroup>
    </Col>
    <Col size="6">
      <FormGroup>
        <Label>Last Name</Label>
        <Input name="last_name" value={this.state.last_name || ''} required />
      </FormGroup>
    </Col>
    <Col size="6">
      <FormGroup>
        <Label>Phone</Label>
        <Input name="phone" value={this.state.phone || ''} />
      </FormGroup>
    </Col>
    <Col size="6">
      <FormGroup>
        <Label>Gender</Label>
        <Select name="gender" value={this.state.gender} options={genderOptions}
          handleOnChange={this.handleChangeGender} />
      </FormGroup>
    </Col>
  </Row>

  Address = () => <Row>
    <Col size="6">
      <FormGroup>
        <Label>Address</Label>
        <Input name="address1" value={this.state.address1 || ''} />
      </FormGroup>
    </Col>
    <Col size="6">
      <FormGroup>
        <Label>Address 2</Label>
        <Input name="address2" value={this.state.address2 || ''} />
      </FormGroup>
    </Col>
    <Col size="6">
      <FormGroup>
        <Label>City</Label>
        <Input name="city" value={this.state.city || ''} />
      </FormGroup>
    </Col>
    <Col size="6">
      <FormGroup>
        <Label>State</Label>
        <Input name="state" value={this.state.state || ''} />
      </FormGroup>
    </Col>
    <Col size="6">
      <FormGroup>
        <Label>Zip</Label>
        <Input name="zip" value={this.state.zip || ''} />
      </FormGroup>
    </Col>
    <Col size="6">
      <FormGroup>
        <Label>Country</Label>
        <Select
          value={this.state._country}
          name="_country"
          options={getCountryOptions()}
        />
      </FormGroup>
    </Col>
    {!['profile', 'admin'].includes(this.props.type) && <>
      <Col size="6">
        <FormGroup>
          <Label>Active</Label>
          <Switch name="active" value={this.state.active || false} />
        </FormGroup>
      </Col>
    </>}
  </Row>

  Password = () => <>
    <Row>
      <Password
        name="password"
        onChange={value => this.handleChangePassword(value)}
        required
      />
    </Row>
    {this.state.adminPainel && <Row>
      <Col size="12">
        <FormGroup>
          <Checkbox name="send_email" value={this.state.send_email || false} title="Send email to user with details" />
        </FormGroup>
      </Col>
    </Row>}
  </>

  CardLayout = () => <>
    <Row>
      <Col size='8'>
        <FormCard title='User information'>
          <this.UserInformation />
        </FormCard>
      </Col>
      <Col size='4'>
        {this.props.type === 'admin' && <AdminForm data={this.props.data} />}
        {this.props.type === 'profile' && <ActiveSessions />}
      </Col>
      <Col>
        <FormCard title='Address'>
          <this.Address />
        </FormCard>
      </Col>
      <Col size='6'>
        <FormCard
          render={this.state.changePassword}
          title='Password'
          headerButtons={<div className='flex items-center gap-2'>
            <Label>Change password</Label>
            <TWSwitch
              onChange={event => this.handleChangePasswordChecked(event.target.checked)}
              value={this.state.changePassword || false}
            />
          </div>}>
          <this.Password />
        </FormCard>
      </Col>
      {this.state.id && <Col size='6'>
        <TwoFactorAuthentication
          type='card'
          id={this.state.id}
          data={this.state.twoFactorAuthentication}
          useUserStore={this.props.useUserStore}
        />
      </Col>}
    </Row >
  </>

  SectionLayout = () => <>
    <Row>
      <Col>
        <FormSection> User information</FormSection>
      </Col>
      <Col>
        <this.UserInformation />
      </Col>
      <Col>
        <FormSection>Address</FormSection>
      </Col>
      <Col>
        <this.Address />
      </Col>
      <Col>
        <FormSection titleClass='flex items-center justify-between'>
          Password
          <div className='flex items-center gap-2 text-base twy-text-base'>
            <Label>Change password</Label>
            <TWSwitch
              onChange={event => this.handleChangePasswordChecked(event.target.checked)}
              value={this.state.changePassword || false}
            />
          </div>
        </FormSection>
        <Separator className='my-2' />
        {this.state.changePassword && <this.Password />}
      </Col>
      {this.state.id && <Col>
        <TwoFactorAuthentication
          type='section'
          id={this.state.id}
          data={this.state.twoFactorAuthentication}
          useUserStore={this.props.useUserStore}
        />
      </Col>}
    </Row >
  </>

  render() {
    return ['profile', 'admin'].includes(this.props.type) ? <this.CardLayout /> : <this.SectionLayout />
  }
}

UserForm.propTypes = {
  data: PropTypes.any,
};

export default UserForm;
